import type { IconSvgObject } from './types';

const DockIcon: IconSvgObject = [
  ["path", { d: "M20 4.00195H4C2.89543 4.00195 2 4.89738 2 6.00195V18.002C2 19.1065 2.89543 20.002 4 20.002H20C21.1046 20.002 22 19.1065 22 18.002V6.00195C22 4.89738 21.1046 4.00195 20 4.00195Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 15.002H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default DockIcon;
